import { router } from "@/services/router";
export default async () => {
  router.replace(router.currentRoute.value.fullPath);
};
